export default "__VITE_ASSET__271c0858__"